import { __assign, __rest } from "tslib";
import React from 'react';
import { withBemMod } from '@bem-react/core';
import { cnLink } from '../Link';
import './Link_theme_pseudo.css';
/**
 * Модификатор, отвечающий за стилевое оформление ссылки.
 * @param {ILinkThemePseudoProps} props
 *
 * @deprecated Рекомендуется использовать withViewDefault
 */
export var withThemePseudo = withBemMod(cnLink(), { theme: 'pseudo' }, function (Link) {
    // TODO: https://github.com/bem/bem-react/issues/381
    return function (_a) {
        var theme = _a.theme, props = __rest(_a, ["theme"]);
        return React.createElement(Link, __assign({}, props));
    };
});
